import React from 'react';
import { CtaButton } from './CtaButton';
export function Closing() {
  return <section id="comprar" className="w-full bg-ink" data-id="element-6" data-mp="3t0hs92rcxyqs">
      <div className="mx-auto max-w-5xl px-6 py-24 md:py-32" data-id="element-7" data-mp="3t09frbz5cvg4">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-8" data-mp="3f9w4azn1qym1">
          <div className="lg:col-span-7" data-id="element-9" data-mp="3jay7frk33uta">
            <h2 className="font-serif text-4xl leading-[1.05] text-cream md:text-6xl" data-id="element-10" data-mp="3j9n5lxa78x4t">
              El futuro es de quien aprende rápido
            </h2>
            <div className="mt-8 space-y-1.5 text-lg leading-relaxed text-cream/70 md:text-xl" data-id="element-11" data-mp="3aa9u6z2ilyhg">
              <p data-id="element-12" data-mp="2waiachpbhnvj">Hace 20 años fue Google.</p>
              <p data-id="element-13" data-mp="2wbtnv98ke9zu">Luego WhatsApp.</p>
              <p data-id="element-14" data-mp="2wcl5fg5bu774">Ahora es IA.</p>
            </div>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-cream/70 md:text-xl" data-id="element-15" data-mp="30bbztfieraqj">
              Los que aprendieron rápido se adelantaron años. Tú puedes ser de esos.
            </p>
            <p className="mt-6 font-serif text-3xl text-terracotta md:text-4xl" data-id="element-16" data-mp="yl0ghov317qg">
              Empezando hoy. Por $20.
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-cream/50" data-id="element-17" data-mp="3r0e7psgmsbtl">
              Sin trucos: $20 es todo lo que pagas. No hay un curso “premium” más caro esperándote
              después, ni suscripciones, ni letra pequeña.
            </p>
          </div>

          <div className="lg:col-span-5 lg:pt-3" data-id="element-18" data-mp="3vsfljitg6alq">
            <div className="border-t-2 border-cream/25 pt-6" data-id="element-19" data-mp="3vv1p77d7w5yo">
              <div className="flex items-end gap-4" data-id="element-20" data-mp="383wch12kptsl">
                <span className="font-serif text-7xl leading-none text-cream md:text-8xl" data-id="element-21" data-mp="3349xam36q3h5">$20</span>
                <span className="pb-2 text-sm font-medium uppercase tracking-wide text-cream/50" data-id="element-22" data-mp="3i10zt485nvaz">
                  USD
                </span>
              </div>
              <div className="mt-8" data-id="element-23" data-mp="3d0wijbzfawjp">
                <CtaButton label="Sí, compro por $20" size="lg" fullWidth href="https://www.tumundoequilibrado.com/cart/51937202536743:1" data-id="element-24" data-mp="xatg566q4myr" />
              </div>
              <p className="mt-5 text-sm text-cream/60" data-id="element-25" data-mp="zene1guhi87p">
                Acceso inmediato · Garantía 7 días · Soporte incluido
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}